import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SeismicDamageListDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-seismicdamagelist-container',
  templateUrl: './seismicdamagelist-container.component.html',
  styleUrls: ['./seismicdamagelist-container.component.scss']
})
export class SeismicDamageListContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  seismicdamagelists$: Observable<SeismicDamageListDto[]>;
  loading: boolean;
  isLoadingSeismicDamageList$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingSeismicDamageList$ = this.gatwayFacade.isLoadingGateway("SeismicDamageList");
    this.seismicdamagelists$ = this.gatwayFacade.loadGateway("SeismicDamageList");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSeismicDamageList(deletedValue: any) {
    this.gatwayFacade.remove("SeismicDamageList", deletedValue);
  }


// this method control both the create and update

  onSubmitSeismicDamageList(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.SeismicDamageLists;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllSeismicDamageList = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id != null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllSeismicDamageList.push(pullData[i]);
    }
  }

// check if the addAllSeismicDamageList array is not empty, then dispatch the data to the store
   if(addAllSeismicDamageList.length > 0) {
    this.gatwayFacade.add('SeismicDamageList', addAllSeismicDamageList);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('SeismicDamageList', allUpdates, ['id']);
  }

   }


}
